import React, {useEffect, useState} from "react";
import { useMemo } from "react";
import { useParams } from "react-router-dom";


import { useClasseContext } from "../context/ClasseContext";


import { usePostApi } from "../hooks/post_api_hook/usePostApi";

import VisuelGroupe from "../components/VueGroupe/VisuelGroupe";
import { useGroupe } from "../hooks/fetch_api_hook/useGroupe";

import Loading from "../components/general/Loading";
import FormGroup from "../components/VueGroupe/FormGroup";
import {useCombinedResults} from "../hooks/fetch_api_hook/useCombinedResults"
import { url } from "../utils/confserveur";
import { useUser } from "../context/UserContext";
import { GraduationCap, School, CheckCircle, Users, ArrowRight, Layers } from "lucide-react";
import { filtrerGroupesDeBesoin } from "../utils/groupesDeBesoin";

function GroupeBesoinsNiveau() {
    const [niveau, setNiveau] = useState('')
    const {etablissementData} = useUser();
    const { data: groupesfromdb, isLoading: isLoadingGroupe } = useGroupe(`?etablissement_id=${etablissementData.id}`);
    const [isGroupe, setisGroupe] = useState('classe')
    const [goNext, setGoNext] = useState(false)
    const [barette, setBarette] = useState();
    const [selectedBarette, setSelectedBarette] = useState('');

    const handleNiveauChange = (item) => {
        let groupes = "";
        if(item !== "6eme" && item !== '5eme'){
            setGoNext(!goNext)
        }
        else{
            setisGroupe("")
        }
        // Les barrettes se lisent sur les GROUPES DE BESOIN seulement : un
        // demi-groupe (« 6G » seul) n'est pas une barrette (est_groupe_de_besoin,
        // servi par le back).
        const groupesDeBesoin = filtrerGroupesDeBesoin(groupesfromdb);
        if(item === '6eme'){
            groupes = groupesDeBesoin.filter(group => group.niveau === "6eme");
        }
        else{
            groupes = groupesDeBesoin.filter(group => group.niveau === "5eme");
        }
        
        const normalizedClassesDetail = groupes.map(group => {
            return JSON.stringify(group.classes_detail.sort());
        });

        const uniqueClassesDetail = [...new Set(normalizedClassesDetail)];
        const uniqueClassesDetailArray = uniqueClassesDetail.map(classes => JSON.parse(classes));
        
        setNiveau(item);
        setBarette(uniqueClassesDetailArray)
        // Reset la barette sélectionnée quand on change de niveau
        setSelectedBarette('');
    }

    const handleChangeBarette = (item) => {
        setSelectedBarette(item)
    }

    const handleGoNext = () => {
        setGoNext(!goNext)
    }

    const handleGoPrev = ()=>{
      setGoNext(false)
    }

    if (isLoadingGroupe){
        return <Loading loadingText={"Chargement des barettes..."} />
    }

    
    return (
        <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 to-sky-50 p-4 sm:p-6 lg:p-8 xl:p-4 2xl:p-6 3xl:p-8">
            {/* Header avec gradient */}
            <div className="bg-gradient-to-r from-blue-500 to-sky-600 rounded-2xl p-6 sm:p-8 xl:p-4 2xl:p-6 3xl:p-8 text-white mb-6 sm:mb-8 xl:mb-4 2xl:mb-6 3xl:mb-8 shadow-xl">
                <div className="flex items-center gap-4 xl:gap-3 2xl:gap-3.5 3xl:gap-4">
                    <div className="w-12 h-12 sm:w-16 sm:h-16 xl:w-10 xl:h-10 2xl:w-12 2xl:h-12 3xl:w-16 3xl:h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                        <GraduationCap className="text-white w-8 h-8 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8" />
                    </div>
                    <div>
                        <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-xl 2xl:text-2xl 3xl:text-4xl font-bold">
                           Affectation des Élèves
                        </h1>
                        <p className="text-blue-100 mt-2 xl:mt-1 2xl:mt-1.5 3xl:mt-2 text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg">
                           Affectez les élèves aux groupes de besoins à partir des résultats d'évaluations
                        </p>
                    </div>
                </div>
            </div>

            {(!niveau || !goNext) && (
                <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 lg:p-10 xl:p-6 2xl:p-8 3xl:p-10 max-w-5xl mx-auto w-full">
                    {/* Étape 1: Sélection du niveau */}
                    <div className="mb-8 sm:mb-10 xl:mb-6 2xl:mb-8 3xl:mb-10">
                        <div className="flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3 mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6">
                            <div className="w-8 h-8 xl:w-7 xl:h-7 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 bg-blue-500 rounded-full flex items-center justify-center">
                                <span className="text-white font-bold text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">1</span>
                            </div>
                            <h2 className="text-xl sm:text-2xl xl:text-lg 2xl:text-xl 3xl:text-2xl font-semibold text-gray-800">
                                Sélection du niveau
                            </h2>
                        </div>

                        <p className="text-gray-600 mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6 text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg">
                            Veuillez sélectionner le niveau pour lequel vous souhaitez composer vos groupes de besoins
                        </p>

                        <div className="grid grid-cols-2 gap-4 sm:gap-6 xl:gap-4 2xl:gap-5 3xl:gap-6 max-w-2xl mx-auto">
                            <button
                                onClick={() => handleNiveauChange("6eme")}
                                className={`relative p-6 sm:p-8 xl:p-4 2xl:p-6 3xl:p-8 rounded-2xl transition-all duration-300 transform hover:scale-105 ${
                                    niveau === "6eme"
                                    ? 'bg-gradient-to-br from-blue-500 to-sky-600 text-white shadow-lg scale-105'
                                    : 'bg-white border-2 border-gray-200 hover:border-blue-300 text-gray-700'
                                }`}
                            >
                                <div className="flex flex-col items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3">
                                    <School className="w-10 h-10 xl:w-7 xl:h-7 2xl:w-8 2xl:h-8 3xl:w-10 3xl:h-10" />
                                    <span className="text-xl sm:text-2xl xl:text-base 2xl:text-lg 3xl:text-2xl font-bold">6ème</span>
                                    {niveau === "6eme" && (
                                        <CheckCircle className="absolute top-3 right-3 xl:top-2 xl:right-2 2xl:top-2.5 2xl:right-2.5 3xl:top-3 3xl:right-3 w-6 h-6 xl:w-5 xl:h-5 2xl:w-5 2xl:h-5 3xl:w-6 3xl:h-6" />
                                    )}
                                </div>
                            </button>

                            <button
                                onClick={() => handleNiveauChange("5eme")}
                                className={`relative p-6 sm:p-8 xl:p-4 2xl:p-6 3xl:p-8 rounded-2xl transition-all duration-300 transform hover:scale-105 ${
                                    niveau === "5eme"
                                    ? 'bg-gradient-to-br from-blue-500 to-sky-600 text-white shadow-lg scale-105'
                                    : 'bg-white border-2 border-gray-200 hover:border-blue-300 text-gray-700'
                                }`}
                            >
                                <div className="flex flex-col items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3">
                                    <School className="w-10 h-10 xl:w-7 xl:h-7 2xl:w-8 2xl:h-8 3xl:w-10 3xl:h-10" />
                                    <span className="text-xl sm:text-2xl xl:text-base 2xl:text-lg 3xl:text-2xl font-bold">5ème</span>
                                    {niveau === "5eme" && (
                                        <CheckCircle className="absolute top-3 right-3 xl:top-2 xl:right-2 2xl:top-2.5 2xl:right-2.5 3xl:top-3 3xl:right-3 w-6 h-6 xl:w-5 xl:h-5 2xl:w-5 2xl:h-5 3xl:w-6 3xl:h-6" />
                                    )}
                                </div>
                            </button>
                        </div>
                    </div>

                    {/* Étape 2: Sélection de la barette */}
                    {(niveau === '6eme' || niveau === '5eme') && (
                        <div className="animate-fadeIn">
                            <div className="border-t border-gray-200 pt-8 mt-8 xl:pt-6 xl:mt-6 2xl:pt-7 2xl:mt-7 3xl:pt-8 3xl:mt-8">
                                <div className="flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3 mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6">
                                    <div className="w-8 h-8 xl:w-7 xl:h-7 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 bg-blue-500 rounded-full flex items-center justify-center">
                                        <span className="text-white font-bold text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">2</span>
                                    </div>
                                    <h2 className="text-xl sm:text-2xl xl:text-lg 2xl:text-xl 3xl:text-2xl font-semibold text-gray-800">
                                        Sélection de la barrette
                                    </h2>
                                </div>

                                <p className="text-gray-600 mb-6 xl:mb-4 2xl:mb-5 3xl:mb-6 text-sm sm:text-base lg:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg">
                                    Veuillez sélectionner la barrette concernée par vos groupes de besoins
                                </p>

                                {barette && barette.length > 0 ? (
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 xl:gap-3 2xl:gap-3.5 3xl:gap-4">
                                    {barette.map((b, index) => (
                                        <button
                                            key={index}
                                            onClick={() => handleChangeBarette(b)}
                                            className={`relative p-4 sm:p-5 xl:p-3 2xl:p-4 3xl:p-5 rounded-xl transition-all duration-300 transform hover:scale-105 ${
                                                selectedBarette === b
                                                ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg scale-105'
                                                : 'bg-white border-2 border-gray-200 hover:border-orange-300 text-gray-700'
                                            }`}
                                        >
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3">
                                                    <Users size={20} className={`xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5 ${selectedBarette === b ? "text-white" : "text-orange-500"}`} />
                                                    <span className="font-semibold text-sm sm:text-base xl:text-xs 2xl:text-sm 3xl:text-base">
                                                        {Array.isArray(b) ? b.join(' • ') : b}
                                                    </span>
                                                </div>
                                                {selectedBarette === b && (
                                                    <CheckCircle size={20} className="xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
                                                )}
                                            </div>
                                        </button>
                                    ))}
                                </div>
                                ) : (
                                <div className="col-span-full flex flex-col items-center justify-center py-12 xl:py-8 2xl:py-10 3xl:py-12">
                                    <div className="w-16 h-16 sm:w-20 sm:h-20 xl:w-14 xl:h-14 2xl:w-16 2xl:h-16 3xl:w-20 3xl:h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4 xl:mb-3 2xl:mb-3.5 3xl:mb-4">
                                        <Layers className="w-8 h-8 sm:w-10 sm:h-10 xl:w-6 xl:h-6 2xl:w-8 2xl:h-8 3xl:w-10 3xl:h-10 text-gray-400" />
                                    </div>
                                    <h3 className="text-lg xl:text-sm 2xl:text-base 3xl:text-lg font-bold text-gray-700 mb-2">Aucune barrette trouvée</h3>
                                    <p className="text-gray-500 text-center max-w-md text-sm xl:text-xs 2xl:text-xs 3xl:text-sm">
                                        Rendez-vous dans <span className="font-semibold">Configuration des groupes</span> pour créer vos groupes par barrette.
                                    </p>
                                </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Bouton de validation */}
                    {(niveau && selectedBarette) && (
                        <div className="mt-10 xl:mt-6 2xl:mt-8 3xl:mt-10 flex justify-center animate-fadeIn">
                            <button
                                onClick={handleGoNext}
                                className="group bg-gradient-to-r from-green-500 to-teal-600 hover:from-green-600 hover:to-teal-700 text-white px-8 sm:px-10 xl:px-6 2xl:px-8 3xl:px-10 py-4 xl:py-3 2xl:py-3.5 3xl:py-4 rounded-xl font-bold text-base sm:text-lg xl:text-xs 2xl:text-sm 3xl:text-lg transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 flex items-center gap-3 xl:gap-2 2xl:gap-2.5 3xl:gap-3"
                            >
                                <span>Valider et continuer</span>
                                <ArrowRight className="group-hover:translate-x-1 transition-transform w-5 h-5 xl:w-4 xl:h-4 2xl:w-[18px] 2xl:h-[18px] 3xl:w-5 3xl:h-5" />
                            </button>
                        </div>
                    )}

                    {/* Indicateur de progression */}
                    <div className="mt-8 sm:mt-10 xl:mt-6 2xl:mt-8 3xl:mt-10">
                        <div className="flex items-center justify-center gap-2">
                            <div className={`h-2 xl:h-1.5 2xl:h-1.5 3xl:h-2 w-20 sm:w-24 xl:w-16 2xl:w-20 3xl:w-24 rounded-full transition-all duration-500 ${
                                niveau ? 'bg-blue-500' : 'bg-gray-300'
                            }`}></div>
                            <div className={`h-2 xl:h-1.5 2xl:h-1.5 3xl:h-2 w-20 sm:w-24 xl:w-16 2xl:w-20 3xl:w-24 rounded-full transition-all duration-500 ${
                                selectedBarette ? 'bg-orange-500' : 'bg-gray-300'
                            }`}></div>
                            <div className={`h-2 xl:h-1.5 2xl:h-1.5 3xl:h-2 w-20 sm:w-24 xl:w-16 2xl:w-20 3xl:w-24 rounded-full transition-all duration-500 ${
                                goNext ? 'bg-green-500' : 'bg-gray-300'
                            }`}></div>
                        </div>
                        <div className="flex justify-center mt-3 xl:mt-2 2xl:mt-2.5 3xl:mt-3 gap-8 sm:gap-12 xl:gap-6 2xl:gap-8 3xl:gap-12 text-xs sm:text-sm xl:text-[10px] 2xl:text-xs 3xl:text-sm text-gray-600">
                            <span className={niveau ? 'text-blue-600 font-semibold' : ''}>Niveau</span>
                            <span className={selectedBarette ? 'text-orange-600 font-semibold' : ''}>Barrette</span>
                            <span className={goNext ? 'text-green-600 font-semibold' : ''}>Création</span>
                        </div>
                    </div>
                </div>
            )}

            {/* Composant suivant */}
            {goNext && (
                <div className="animate-fadeIn">
                    <Gniveau selectedBarette={selectedBarette} niveau={niveau} handleBack={handleGoNext}/>
                </div>
            )}
        </div>
    );
}

export default GroupeBesoinsNiveau;



function Gniveau ({selectedBarette,niveau , handleBack}) {
  // Les variables partagé par toute la session (context, lien, navigateur local storage)
    const {idclasse} = useParams();

    const {etablissementData} = useUser();
    const {classeNom} = useClasseContext(); // On recupère le nom de la classe depuis le context (initialisé également à la selection du menu)
    const [selectedAutomatismes, setSelectedAutomatismes] = useState([])
    const [selectedProblemes, setSelectedProblemes] = useState([])
    const [selectedLexique, setSelectedLexique] = useState([])
    const [selectedCompetences, setSelectedCompetences] = useState([])
    const [selectedComprehension, setSelectedComprehension] = useState([])
   

    // L'évaluation bilan sélectionné dans la liste déroulante.
    const [selectedEvalBilan, setSelectedEvalBilan] = useState(null)

    // L'évaluation en classe sélectionné dans la liste déroulante.
    const [selectedEvalClasse, setSelectedEvalClasse] = useState(null)
    // Mode de composition
    const [conservationMode, setConservationMode] = useState(false)
  
    const [nbGroupes , setNbGroupes] = useState(0)

  
   
    const [typeEval, setTypeEval] = useState("Evaluation Nationale")
    const [listEvalBilan, setListEvalBilan] = useState([])
    const [listEvalClasse, setListEvalClasse] = useState([])

    const[dataGroupe, setDataGroupe] = useState(null)

    const[isSubmit, setIsSubmit] = useState(false)


    const [selectedEval , setSelectedEval] = useState(null)

    const [{data: data_filtered, isLoading: isLoadingPost , isError: isErrorPost }, doPost] = usePostApi(url + "eleves_evaluations_nat/groupes_besoins/");

   const { data: groupesfromdb ,  isLoading: isLoadingGroupe } = useGroupe(`?etablissement_id=${etablissementData.id}`);

   const {data:eleves, isLoading:isLoadingCombinedResults} = useCombinedResults(`?etablissement_id=${etablissementData.id}&classes_details=${selectedBarette}`);

    const { user } = useUser();

   const [listGroupes, setListGroupes] = useState(groupesfromdb)

 // Après la ligne 171, ajouter ce filtre intelligent
    const elevesFiltres = useMemo(() => {
  if (!eleves?.eleves || !user?.matiere) return eleves;
  
  // Vérifier si TOUS les élèves ont une matière définie
  const tousOntUneMatiere = eleves.eleves.every(eleve => 
    eleve.matiere !== null && eleve.matiere !== undefined && eleve.matiere !== ''
  );
  
  // Si tous ont une matière, on filtre
  if (tousOntUneMatiere) {
   
    return {
      ...eleves,
      eleves: eleves.eleves.filter(eleve => 
        eleve.matiere === user.matiere.toLowerCase()
      )
    };
  }
  
  
  return eleves;
  
}, [eleves, user?.matiere]);

   // Extraire la liste des classes affectées aux élèves
const classesDisponibles = useMemo(()=> {

  if(elevesFiltres && elevesFiltres.eleves && elevesFiltres.eleves.length > 0){
  return elevesFiltres.eleves.map(eleve => eleve.classe_nom);
  }
}, [elevesFiltres])
// Pour éviter les doublons, on peut transformer ce tableau en Set
const classesDisponiblesSet = new Set(classesDisponibles);

// Vérifier quelles classes de selectedBarette ne sont pas présentes dans classesDisponiblesSet
const classesManquantes = selectedBarette.filter(classe => !classesDisponiblesSet.has(classe));
const elevesNonAffectes = useMemo(() => {

    return elevesFiltres?.eleves?.filter(eleve => {
      // Créer une version normalisée du nom et du prénom de l'élève
      const nomCompletEleve = `${eleve.nom.toLowerCase()} ${eleve.prenom.toLowerCase()} ${eleve.id}`;

      // Vérifier si cet élève est présent dans un des groupes
      const estPresentDansUnGroupe = listGroupes.some(groupe => {
        return groupe.eleves.some(eleveGroupe => {
          const nomCompletEleveGroupe = `${eleveGroupe.nom.toLowerCase()} ${eleveGroupe.prenom.toLowerCase()} ${eleve.id}`;
          return nomCompletEleve === nomCompletEleveGroupe;
        });
      });

      // Retourner vrai si l'élève n'est présent dans aucun groupe
      return !estPresentDansUnGroupe;
    });
  }, [elevesFiltres, listGroupes]);  // Ajouter eleves et listGroupes comme dépendances
 

    useEffect(() => {
      if(elevesFiltres?.eleves){
        // Objet pour regrouper les évaluations par evalId
const evaluationsMap = {};
// Parcourir chaque élève
elevesFiltres.eleves.forEach(eleve => {
  // On regroupe les résultats de l'élève par evalId
  const resultsByEval = {};
  eleve.resultats.forEach(resultat => {
    const evalId = resultat.evalId;
    if (!resultsByEval[evalId]) {
      resultsByEval[evalId] = [];
    }
    resultsByEval[evalId].push(resultat);
  });
  // Pour chaque évaluation pour cet élève, vérifier si ses résultats sont complets
  Object.keys(resultsByEval).forEach(evalId => {
    const resultsForEval = resultsByEval[evalId];
    // On considère les résultats comme complets si, pour cet élève,
    // tous les objets dans resultsForEval ont une propriété "scores" renseignée.
    const isCompleteForThisEleve = resultsForEval.every(r => r.scores !== null && r.scores !== undefined && r.scores !==0);

    // Si cet élève a tous ses scores complétés pour cette évaluation,
    // alors on l'ajoute comme candidat pour cette évaluation.
    if (isCompleteForThisEleve) {
      if (!evaluationsMap[evalId]) {
        evaluationsMap[evalId] = {
          evalId:  parseInt(evalId,10),
          evalTitre: resultsForEval[0].evalTitre, // On récupère par exemple le titre commun
          candidats: [] // Liste des élèves candidats pour cette évaluation
        };
      }
      evaluationsMap[evalId].candidats.push(eleve);
    }
  });
});
// On ne retient que les évaluations pour lesquelles il y a au moins 1 élève candidat
const listEvals = Object.values(evaluationsMap)
  .filter(evaluation => evaluation.candidats.length > 0)
  .reduce((uniques, ev) => {
    // on compare par titre
    if (!uniques.find(u => u.evalTitre === ev.evalTitre)) {
      uniques.push(ev);
    }
    return uniques;
  }, []);
    setListEvalClasse(listEvals);
      }
    }, [elevesFiltres]);


    useEffect(() => {
      if (groupesfromdb) {
        // Filtrer : groupes de besoin de la barrette ET de la matière du prof
        // connecté. (Le délégué reçoit TOUS les groupes du backend ; pour la
        // composition par résultats, on ne garde que ceux de SA matière.) Un
        // demi-groupe d'une classe de la barrette (6G_G1 dans 6BG) n'est pas un
        // groupe à composer, et son verrou ne fait plus dire « vos groupes sont
        // déjà formés ».
        const filteredGroupes = filtrerGroupesDeBesoin(groupesfromdb).filter(g =>
            g.classes_detail.every(classDetail => selectedBarette.includes(classDetail)) &&
            (!user?.matiere || g.matiere === user.matiere)
        );
        setListGroupes(filteredGroupes);
      }
    }, [groupesfromdb, selectedBarette, user?.matiere]); // + matière du prof connecté

    const elevesParCluster = useMemo(() => {
        // Initialiser un objet pour contenir les élèves organisés par cluster
        const clusters = {};
       
        if (dataGroupe && Array.isArray(dataGroupe)) {
     
         dataGroupe.forEach(eleve => {

          const {  Cluster } = eleve;
         
          let questions = "";

          if(selectedEvalClasse){
            questions = Object.keys(eleve).filter(key => key !== "Cluster" && key !== "id"&& key !== "nom" && key!== "prenom" && key !=="score_obtenu" && key!=="classe_nom");
          }
          else{
            questions = Object.keys(eleve).filter(key => key.endsWith("score"));
          }
          
          // Calculer le score total pour l'élève
          let scoreTotal = questions.reduce((total, current) => {
              return total + eleve[current];
          }, 0) 
        
          // Ajouter le score total à l'objet élève
          eleve.score_obtenu = scoreTotal;
          // Vérifier si le cluster existe déjà dans l'objet clusters
          if (!clusters[Cluster]) {
            clusters[Cluster] = []; // Initialiser le cluster s'il n'existe pas
          }
          // Ajouter l'élève au cluster correspondant
          clusters[Cluster].push(eleve);
        });
                }
        // Assurer que le nombre de clusters dans 'clusters' correspond au nombre de groupes dans 'listGroupes'
        const currentClusterCount = Object.keys(clusters).length;
        const requiredClusterCount = listGroupes.length;

        if (currentClusterCount < requiredClusterCount) {
          // Ajouter des clusters manquants
          for (let i = currentClusterCount; i < requiredClusterCount; i++) {
            clusters[i] = clusters[i] || []; // Créer un nouveau cluster s'il n'existe pas
          }
        }
         // On push tous les eleves absents lors du contrôle dans le dernier cluster.
         let tousLesIdsDesElevesDansClusters;
       
         tousLesIdsDesElevesDansClusters = Object.values(clusters).flatMap(group =>  group.map(eleve =>  eleve.id));
      
         const elevesNonAffectes =  elevesFiltres?.eleves?.filter(eleve => !tousLesIdsDesElevesDansClusters.includes(eleve.id));
                   // Trouver l'index du dernier cluster
         const dernierClusterIndex = Object.keys(clusters).length - 1;

         // Ajouter chaque élève non affecté au dernier cluster, un par un
         (clusters.length > 0 && elevesNonAffectes) && Object.values(elevesNonAffectes).forEach(eleve => {
           clusters[dernierClusterIndex].push(eleve);
         });
    
        return clusters;
      }, [dataGroupe, listGroupes, elevesFiltres, selectedEvalClasse]);

    
    


     // Utiliser useMemo pour recalculer les labels uniquement si classeNom change

     const labelAutomatismesNat = useMemo(() => {
      // S'assure que selectedEval et selectedEval.questions sont définis
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
   

      if (!evaluation || !evaluation.questions) {
        return {};
      }
      return evaluation.questions
        .filter(question => question.type_label === "Automatisme")
        .reduce((acc, question) => {
          acc[question.question_num] = question.nom_label;
          return acc;
        }, {});
    }, [selectedEval]);

    
    const labelProblèmesNat = useMemo(() => {
      // S'assure que selectedEval et selectedEval.questions sont définis
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
 
      if (!evaluation || !evaluation.questions) {
        return {};
      }
      return evaluation.questions
        .filter(question => question.type_label === "Résolution de problèmes")
        .reduce((acc, question) => {
          acc[question.question_num] = question.nom_label;
          return acc;
        }, {});
    }, [selectedEval]);


    const AutomatismeQuestionsNat = useMemo(() => {
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
  
      if (!evaluation || !evaluation.questions) {
        return {};
      }
      return evaluation.questions
        .filter(question => question.type_label === "Automatisme")
        .reduce((acc, question) => {
          const reponses = Array.isArray(question.reponses)
            ? question.reponses.map(rep => rep.contenu)
            : []; // Fallback sur un tableau vide si ce n'est pas un tableau
          
          acc[question.question_num] = {
            "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
            "reponses": reponses,
            "image": question.image,
            "bonne_reponse": question.bonne_reponse
          };
          
          return acc;
        }, {});
    }, [selectedEval]);
  
    const ProblèmesQuestionsNat = useMemo(() => {
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
   
      
      if (!evaluation || !evaluation.questions) {
        return {};
      }  
      return evaluation.questions
        .filter(question => question.type_label === "Résolution de problèmes")
        .reduce((acc, question) => {
          const reponses = Array.isArray(question.reponses)
            ? question.reponses.map(rep => rep.contenu)
            : []; // Fallback sur un tableau vide si ce n'est pas un tableau
          
          acc[question.question_num] = {
            "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
            "reponses": reponses,
            "image": question.image,
            "bonne_reponse": question.bonne_reponse,
            
          };   
          return acc;
        }, {});
    }, [selectedEval]);

  const labelLexiqueNat = useMemo(() => {
  let evaluation = selectedEval;
  if (!evaluation || !evaluation.questions) return {};
  
  return evaluation.questions
    .filter(question => question.type_label === "Lexique")
    .reduce((acc, question) => {
      acc[question.question_num] = question.nom_label;
      return acc;
    }, {});
}, [selectedEval]);

const labelComprehensionEcriteNat = useMemo(() => {
  let evaluation = selectedEval;
  if (!evaluation || !evaluation.questions) return {};
  return evaluation.questions
    .filter(question => question.type_label.startsWith("Compréhension de l'écrit"))
    .reduce((acc, question) => {
      // Extraire le nom du texte (aligné avec ComprehensionEcriteQuestionsNat)
      let texteName = question.type_label.replace("Compréhension de l'écrit ", "");
      if (texteName.startsWith("Document ")) {
        texteName = texteName.replace("Document ", "");
      }
      const key = `${texteName} ${question.question_num}`;
      acc[key] = question.nom_label;
      return acc;
    }, {});
}, [selectedEval]);

const labelCompetencesLangagieresNat = useMemo(() => {
  let evaluation = selectedEval;
  if (!evaluation || !evaluation.questions) return {};
  
  return evaluation.questions
    .filter(question => question.type_label === "Compétences langagières et linguistiques")
    .reduce((acc, question) => {
      acc[question.question_num] = question.nom_label;
      return acc;
    }, {});
}, [selectedEval]);

// QUESTIONS FRANÇAIS

const LexiqueQuestionsNat = useMemo(() => {
  let evaluation = selectedEval;
  if (!evaluation || !evaluation.questions) return {};
  
  return evaluation.questions
    .filter(question => question.type_label === "Lexique")
    .reduce((acc, question) => {
      const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => rep.contenu) // Juste le contenu, comme pour les maths !
        : [];
      
      acc[question.question_num] = {
        "question": question.texte,
        "reponses": reponses,
        "image": question.image,
        "bonne_reponse": question.bonne_reponse
      };
      
      return acc;
    }, {});
}, [selectedEval]);

const ComprehensionEcriteQuestionsNat = useMemo(() => {
  let evaluation = selectedEval;
  if (!evaluation || !evaluation.questions) return {};
  
  return evaluation.questions
    .filter(question => question.type_label.startsWith("Compréhension de l'écrit"))
    .reduce((acc, question) => {
      const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => rep.contenu) // Juste le contenu !
        : [];
      
      // Extraire le nom du texte depuis type_label
      let texteName = question.type_label.replace("Compréhension de l'écrit ", "");
      
      // Si c'est "Document Sommeil", on garde juste "Sommeil"
      if (texteName.startsWith("Document ")) {
        texteName = texteName.replace("Document ", "");
      }
      
      // Créer la clé composite "Arachné Q1" ou "Sommeil Q1"
      const cleComposite = `${texteName} ${question.question_num}`;
      
      acc[cleComposite] = {
        "question": question.texte,
        "reponses": reponses,
        "image": question.image,
        "bonne_reponse": question.bonne_reponse,
        "question_num": question.question_num
      };
      
      return acc;
    }, {});
}, [selectedEval]);

const CompetencesLangagieresQuestionsNat = useMemo(() => {
  let evaluation = selectedEval;
  if (!evaluation || !evaluation.questions) return {};
  
  return evaluation.questions
    .filter(question => question.type_label === "Compétences langagières et linguistiques")
    .reduce((acc, question) => {
      const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => {
            const responseObj = { contenu: rep.contenu };
            if (rep.image) {
              responseObj.image = rep.image;
            }
            return responseObj;
          })
        : [];
      
      acc[question.question_num] = {
        "question": question.texte,
        "reponses": reponses,
        "image": question.image,
        "bonne_reponse": question.bonne_reponse
      };
      
      return acc;
    }, {});
}, [selectedEval]);
    
    const handleSubmit = async (bool,conservation) => {
     
      if(bool){

                    // Filtrer les résultats pour chaque élève
                  const filteredEleves = elevesFiltres?.eleves?.map(eleve => {
                    const filteredResults = eleve.resultats.filter(resultat => resultat.evalTitre ===  selectedEvalClasse.evalTitre);
                    return {
                      id: eleve.id,
                      classe_nom: eleve.classe_nom,
                      nom: eleve.eleve_gar ? eleve.eleve_gar_nom : eleve.nom,
                      prenom: eleve.eleve_gar ? eleve.eleve_gar_prenom : eleve.prenom,
                      resultats: filteredResults
                    };
                  });
              // Envoyer les données avec une clé, par exemple 'eleves'
              const payload = { eleves: filteredEleves , nb_groupes: nbGroupes ,  listgroupes : listGroupes.map((groupe) => groupe.id)};
              // Ajouter des informations pour la conservation des groupes existants
              if (conservation) {
                setConservationMode(true)
                payload.utiliser_groupes_existants = true;
                payload.etablissement_id = etablissementData.id; // Exemple, si disponible dans le contexte
                payload.niveau = niveau; // Niveau pour filtrer les groupes
                payload.titre = selectedEvalClasse.evalTitre;
              }
              else{
                setConservationMode(false)
              }

           
              await doPost(payload);
               
      }
      else {
        
              const payload = {
                automatismes: selectedAutomatismes,
                problemes: selectedProblemes,
                lexique : selectedLexique,
                competences : selectedCompetences,
                comprehension: selectedComprehension,
                count: (selectedAutomatismes?.length + selectedProblemes?.length) || (selectedLexique?.length + selectedComprehension?.length) || selectedCompetences?.length,
                nb_groupes : nbGroupes,
                qautomatismes:  AutomatismeQuestionsNat,
                qproblemes :  ProblèmesQuestionsNat,
                qlexique : LexiqueQuestionsNat,
                qcomprehension : ComprehensionEcriteQuestionsNat,
                qcompetences: CompetencesLangagieresQuestionsNat,
                titre : selectedEvalBilan ? selectedEvalBilan.titre : "Evaluation Nationale",
                listgroupes : listGroupes.map((groupe) => groupe.id),
              };
              if (classeNom) { // Vérifie si classeNom existe (n'est pas null, undefined, ou une chaîne vide)
                payload.classeId = idclasse;
            } else if (etablissementData) { // Si classeNom n'existe pas, vérifie si etablissementData existe
                payload.etablissement_id = etablissementData.id; // Ajoute etablissementId au payload
            } else {
                // Gérer le cas où ni classeNom ni etablissementData ne sont disponibles.
                console.error("Ni classeNom ni etablissementData ne sont disponibles. Impossible de créer le payload.");
                // Vous pourriez ici lancer une exception, afficher un message d'erreur à l'utilisateur, ou prendre une autre action appropriée.
                return; // Important de stopper l'exécution pour ne pas envoyer une requête incorrecte
            }
            // Ajouter des informations pour la conservation des groupes existants
            if (conservation) {
                setConservationMode(true)
                payload.utiliser_groupes_existants = true;
                payload.niveau = niveau; // Niveau pour filtrer les groupes
              }
              else{
                setConservationMode(false)
              }

           
              
                  await doPost(payload);
                 
      }

    

  
    }



    const handleAutomatismesChange  = ( selectedOptions) => {
        setSelectedAutomatismes(selectedOptions.map(option => option.value))
    } 

    const handleProblemesChange  = ( selectedOptions) => {
        setSelectedProblemes(selectedOptions.map(option => option.value))
    } 
    const handleLexiqueChange = (selectedOptions) => {
      setSelectedLexique(selectedOptions.map(option=> option.value))
    }
    const handleCompetencesChange = (selectedOptions) => {
      setSelectedCompetences(selectedOptions.map(option=> option.value))
    }
    const handleComprehensionChange = (selectedOptions) => {
      setSelectedComprehension(selectedOptions.map(option=> option.value))
    }
    const handleNbGroupeChange = (e) => {
       setNbGroupes(e.target.value)
    }

    const handleTypeEvalChange = (e,evalnat) => {
      setListEvalBilan(evalnat?.filter(e => 
        e.titre !== "Evaluation Nationale" && 
        e.classe === parseInt(idclasse, 10) &&
        e.eleves_reponses.some(eleve => eleve.reponses)
      ))
      setSelectedAutomatismes([])
      setSelectedProblemes([])
      Object.keys(listGroupes).length === 0 ? setNbGroupes(null) : setNbGroupes(Object.keys(listGroupes).length)
      setTypeEval(e.target.value)
      setSelectedEval(null)
      setSelectedEvalClasse(null)
      setSelectedEvalBilan(null)
      
    }

    const handleNationalEval = (e,evalnat) => {
      setSelectedEvalClasse(null)
      setSelectedEvalBilan(null)
      setSelectedAutomatismes([])
      setSelectedProblemes([])
      Object.keys(listGroupes).length === 0 ? setNbGroupes(null) : setNbGroupes(Object.keys(listGroupes).length)
      setTypeEval(e.target.value)
      setSelectedEval(evalnat.find(evaluation => evaluation.titre ==="Evaluation Nationale"));
    }

    const handleEvalBilanChange = (event) => {
      // Récupère la valeur de l'option sélectionnée
      const selectedTitre = event.target.value;
      setSelectedEvalBilan(listEvalBilan.find(e => e.titre === selectedTitre )); // Ou e.titre

    };

    const handleEvalClasseChange = (event) => {
      setSelectedEvalClasse(listEvalClasse.find(e => e.evalTitre === event.target.value))
    }


    useEffect(() => {
        if (!isLoadingPost && !isErrorPost && data_filtered) {
      
            const cleanData = data_filtered.replace(/NaN/g, 'null'); // Remplace NaN par null
            try {
                const parsedData = JSON.parse(cleanData);
              
                // Compter les élèves par cluster
                const clusterCounts = {};
                parsedData.forEach(eleve => {
                  const cluster = eleve.Cluster;
                  clusterCounts[cluster] = (clusterCounts[cluster] || 0) + 1;
                });
             
             
            

                setDataGroupe(parsedData);
                setIsSubmit(true);
              } catch (error) {
                console.error('Erreur lors de l\'analyse de data_filtered:', error);
              }
          // Ici, vous pouvez manipuler 'data' comme vous le souhaitez
        }
      }, [isLoadingPost, isErrorPost, data_filtered,elevesFiltres]); // Ces dépendances déclenchent l'effet à chaque changement

      if (classesManquantes && classesManquantes.length > 0 &&!isLoadingGroupe &&!isLoadingCombinedResults &&!isLoadingPost) {
        return <div className=" bg-red-200 p-2 border-2 border-red-600"> 
        <p className=" text-red-700 text-xl">Aucun élève détecté dans les classes suivantes : {classesManquantes.map((c)=> c)}
        </p>
        </div>
      }


      if(isLoadingPost){
        return <Loading loadingText={"Chargement du loading post"} /> 
      }
     else if(isLoadingGroupe){
      
      return <Loading loadingText={"Chargement des groupes page Groupe besoins"} /> 
     }
     else if(isLoadingCombinedResults){
      return <Loading loadingText={"Chargement des élèves"} />

     }
     else if(elevesFiltres && elevesFiltres.eleves &&  elevesFiltres.eleves.length ===0){
        return <div className=" text-lg  font-bold">
          Aucun d'élève de 5ème n'as pu être récupérer. Veuillez verifier que vous avez bien importer vos élèves de : {selectedBarette}
        </div>
      
     }
     
    else if(listGroupes.length !==0 && listGroupes.some((l) => l.statut !== true))
        {
    return( 
      <div className=" bg-white p-10 rounded-3xl h-fit
      text-base font-bold w-fit flex 
       shadow-sm shadow-black 
        flex-col gap-5"> Vos groupes de besoins sont déjà formés. Pour composer un nouveau groupe de besoin, veuillez les déverrouiller dans l'espace
         'Configuration des groupes'.
       </div>
    )

  }
  else if(listGroupes.length ===0 && classeNom[0] !== '4' && classeNom[0] !== '3') {
    return(
      <div className=" bg-white p-10 rounded-3xl
      text-base font-bold w-fit justify-center items-center flex text-center
       shadow-sm shadow-black">Il semblerait qu'aucun groupe n'ait été créé dans votre établissement. Veuillez consulter l'espace 'Configuration des groupes'.</div>
    )
  }

  else  {
  return (
    <div>
    <div className="px-3 sm:px-6">
       
      </div>
   

       { !isSubmit   ?
       <>
        <button 
          className="px-3 py-1.5 sm:px-4 sm:py-2 bg-orange-500 text-white rounded-lg font-medium hover:bg-orange-600 transition-all duration-200 hover:-translate-y-0.5 text-xs sm:text-sm"
          onClick={handleBack}
        >
          ← RETOUR
        </button>
           <FormGroup  handleNationalEval={handleNationalEval} typeEval = {typeEval} 
           handleAutomatismesChange={handleAutomatismesChange}
    handleProblemesChange={handleProblemesChange} labelAutomatismesNat={labelAutomatismesNat}
      selectedAutomatismes={selectedAutomatismes} selectedProblemes={selectedProblemes} 
 labelProblèmesNat={labelProblèmesNat}
    labelLexiqueNat={labelLexiqueNat} handleLexiqueChange={handleLexiqueChange} selectedLexique={selectedLexique}
    labelCompetencesLangagieresNat={labelCompetencesLangagieresNat} handleCompetencesChange={handleCompetencesChange} selectedCompetences={selectedCompetences}
    labelComprehensionEcriteNat={labelComprehensionEcriteNat} handleComprehensionChange={handleComprehensionChange} selectedComprehension={selectedComprehension}
    handleNbGroupeChange={handleNbGroupeChange}
  listGroupes={listGroupes} listEvalBilan={listEvalBilan}
    selectedEvalBilan={selectedEvalBilan} handleEvalBilanChange={handleEvalBilanChange }nbGroupes={nbGroupes} handleSubmit={handleSubmit} handleTypeEvalChange={handleTypeEvalChange}
    elevesNonAffectes={elevesNonAffectes}
     listEvalClasse={listEvalClasse} handleEvalClasseChange={handleEvalClasseChange}
      selectedEvalClasse={selectedEvalClasse}
      selectedBarette={selectedBarette}  /> 
       </>


        :
            <VisuelGroupe elevesParCluster={elevesParCluster} selectedAutomatismes={selectedAutomatismes} selectedProblemes={selectedProblemes} 
            labelAutomatismes={ labelAutomatismesNat} labelProblèmes={labelProblèmesNat}
            selectedLexique={selectedLexique}  selectedComprehension={selectedComprehension}
            labelLexiqueNat={labelLexiqueNat} labelComprehensionEcriteNat={labelComprehensionEcriteNat}
            selectedCompetences={selectedCompetences} labelCompetencesLangagieresNat={labelCompetencesLangagieresNat}
            listGroupes={listGroupes} eleves={elevesFiltres} 
           selectedEvalClasse={selectedEvalClasse} selectedBarette={selectedBarette} setIsSubmit={setIsSubmit}
           conservationMode={conservationMode}
            />
}

        


      
    </div>

  )
}
}
